import { el } from "./dom";

/** A dismissible top-right card shown while no MIDI device is connected — in
 *  addition to the top-bar "⚠ No MIDI" text. `×` hides it until the next
 *  disconnect; connecting a device (`hide`) re-arms it. */
export function createMidiWarning(parent: HTMLElement): { show(): void; hide(): void } {
  let dismissed = false;
  const card = el("div", { class: "midi-warning" });
  Object.assign(card.style, {
    position: "fixed",
    top: "12px",
    right: "12px",
    maxWidth: "280px",
    padding: "12px 14px",
    background: "#2a1414",
    border: "1px solid #ff5a5a",
    borderRadius: "8px",
    color: "#ffd7d7",
    font: "13px system-ui, sans-serif",
    zIndex: "1000",
    display: "none",
    // Click-through: the card is informational and overlaps top-bar controls, so
    // only its close button captures pointer events (the rest passes to the UI).
    pointerEvents: "none",
  });

  const close = el<HTMLButtonElement>("button", { textContent: "×", title: "Dismiss" });
  Object.assign(close.style, {
    float: "right",
    background: "none",
    border: "none",
    color: "inherit",
    fontSize: "18px",
    lineHeight: "1",
    cursor: "pointer",
    pointerEvents: "auto",
  });
  close.onclick = () => {
    dismissed = true;
    card.style.display = "none";
  };

  card.append(
    close,
    el("strong", { textContent: "No MIDI keyboard detected" }),
    el("p", {
      textContent: "Showing a demo. Connect your piano to play along.",
      style: "margin:6px 0 0",
    }),
    el("p", {
      class: "muted",
      textContent: "Needs a Web MIDI browser (Chrome/Edge) over https or localhost.",
      style: "margin:6px 0 0; font-size:11px; opacity:.7",
    }),
  );
  parent.append(card);

  return {
    show() {
      if (!dismissed) card.style.display = "";
    },
    hide() {
      dismissed = false; // re-arm for the next disconnect
      card.style.display = "none";
    },
  };
}
